import React, { memo } from 'react';
import { TableCell, TextField } from '@mui/material';

interface EditableCellProps {
  value: string | number;
  isEditing: boolean;
  canEdit: boolean;
  width?: string;
  onDoubleClick: () => void;
  onSave: (value: string) => void;
  onCancel: () => void;
  onChange: (value: string) => void;
  type?: 'text' | 'number';
}

const EditableCell: React.FC<EditableCellProps> = memo(({
  value,
  isEditing,
  canEdit,
  width = '100px',
  onDoubleClick,
  onSave,
  onCancel,
  onChange,
  type = 'text'
}) => {
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      onSave(String(value));
    } else if (e.key === 'Escape') {
      onCancel();
    }
  };

  if (isEditing) {
    return (
      <TableCell
        sx={{ width: '80px', padding: '0' }}
        onBlur={() => onSave(String(value))}
      >
        <TextField
          size="small"
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyPress}
          sx={{
            width: '80px',
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: 'primary.main',
              },
            },
          }}
          autoFocus
        />
      </TableCell>
    );
  }

  return (
    <TableCell
      sx={{
        width,
        cursor: canEdit ? 'pointer' : 'default',
      }}
      onDoubleClick={onDoubleClick}
    >
      {value}
    </TableCell>
  );
});

EditableCell.displayName = 'EditableCell';

export default EditableCell;

